"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_jss_1 = require("react-jss");
var UserCounter = function (_a) {
    var headline = _a.headline, count = _a.count, subLine = _a.subLine;
    var styles = useStyles();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: styles.root }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: styles.headline }, { children: headline })), (0, jsx_runtime_1.jsx)("span", __assign({ className: styles.count }, { children: count })), (0, jsx_runtime_1.jsx)("span", __assign({ className: styles.subLine }, { children: subLine }))] })));
};
exports.default = UserCounter;
var useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        textAlign: "center",
    },
    headline: {},
    count: {
        fontSize: "3rem",
        display: "block",
        lineHeight: "1.5em",
    },
    subLine: {}
});
